import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

export default function BulkUploadGroupSimple({
    showUpload,
    closeModal,
    refreshPage,
}) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState(null);

    const resetForm = () => {
        setFile(null);
        setValidationError({});
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleClose = () => {
        resetForm();
        closeModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please select a file to upload");
            return;
        }

        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await axiosInstance.post(
                "/user/simple_code/upload",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const responseData = response.data;
            const importData = responseData.data;

            handleClose();
            refreshPage();

            // Show import summary
            toast.success(
                `Imported ${importData.successful_imports} customers successfully`
            );

            // Show detailed errors if any
            if (importData.failed_imports > 0) {
                toast.warn(`${importData.failed_imports} imports failed`);

                importData.errors.forEach((error) => {
                    const errorMessages = Object.entries(error.errors.item || error.errors)
                        .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                        .join("; ");
                    toast.error(`Row ${error.row}: ${errorMessages}`);
                });
            }

        } catch (error) {
            if (error.response) {
                if (error.response.status === 422) {
                    const errors = error.response.data.data.errors;
                    setValidationError(errors);
                    toast.error("Validation failed. Please check the file format.");

                    // Show specific file validation errors
                    if (errors.file) {
                        toast.error(`File error: ${errors.file.join(", ")}`);
                    }
                } else {
                    toast.error(error.response.data.message || "Failed to import customers");
                }
            } else {
                toast.error("An error occurred while uploading the file");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="CreateCSP">
            <Modal show={showUpload} onHide={handleClose} dialogClassName="modal-md">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Upload Group and Simple Code</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlFile1">
                            <div>
                                <h6>Upload Excel Document</h6>
                                <small className="text-muted">
                                    Accepted formats: .xlsx, .xls (Max 2MB)
                                </small>
                            </div>
                            <Form.Control
                                type="file"
                                name="file"
                                onChange={handleFileChange}
                                accept=".xlsx,.xls"
                                isInvalid={!!validationError.file}
                                disabled={isLoading}
                            />
                            <Form.Control.Feedback type="invalid">
                                {validationError.file?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className="mt-3">
                            <small className="text-muted">
                                Required columns: group_name, simple_code
                                <br />
                                Ensure phone numbers are formatted as text (use quotes or text formatting),
                                and all required fields are filled.
                            </small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ backgroundColor: "#c4281b", borderColor: "#c4281b" }}
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? "Uploading..." : "Upload"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}